<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><a href="#/c001">J. F. K. | Pier-Giorgio Tomatis</a></p>
<p><a href="#/c002">J.F.K. | Join to Fauci's Killer | Pier-Giorgio TOMATIS | Novel</a></p>
<p><a href="#/c003">by Nello Strazzeri</a></p>
<p><span href="#/c004" title="Link target outside of Sample">General index</span></p>
<p><span href="#/c005" title="Link target outside of Sample">THANK YOU.</span></p>
<p><span href="#/c006" title="Link target outside of Sample">(for Open "friends")</span></p>
<p><span href="#/c007" title="Link target outside of Sample">© 2022, J. F. K.-Join the Fauci's Killer, Pier-Giorgio Tomatis.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0cfa9f26